import generateCrudConstants from './baseCrudConstants';

export default {
  ...generateCrudConstants('EVENTBRITE_EVENTS', 'R', [
    'EVENTBRITE_INITIALIZE',
    'EVENTBRITE_AUTHORIZED',
    'EVENTBRITE_UNAUTHORIZED',
    'EVENTBRITE_DISCONNECTED',
    'EVENTBRITE_REDIRECTING',
  ]),
  ...generateCrudConstants('EVENTBRITE_EVENT', 'R'),
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/eventbriteConstants.js